<template>
  <b-table
    :loading="isLoading"
    :paginated="paginated"
    :per-page="perPage"
    :striped="isStriped"
    :hoverable="hoverable"
    :data="results"
    default-sort="execution_date"
    default-sort-direction="desc"
    slot="content"
  >
    <template slot-scope="props">
      <b-table-column label="Lección" field="lesson_name" sortable>
        <lesson-pdf-button :lesson-id="props.row.lesson_id" :text="props.row.lesson_name"/>
      </b-table-column>
      <b-table-column label="Jinete" field="rider_lastname" sortable>
        <link-to-detail type="rider" :resource-id="props.row.rider_id"> {{`${props.row.rider_lastname} ${props.row.rider_name}`}} </link-to-detail>
      </b-table-column>
      <b-table-column label="Fecha" field="execution_date" centered sortable>{{ moment(props.row.execution_date, 'YYYY-MM-DD') | moment('L')}}</b-table-column>
      <!-- <b-table-column label="Evaluación" field="id">{{ props.row.event_name }}</b-table-column> -->
      <b-table-column label="Salida" field="start_estimated" centered>{{ props.row.start_estimated | moment('LT')}}</b-table-column>
      <b-table-column label="Puntaje" field="horse" centered>
        <score-tag :score="parseFloat(props.row.final_score)" :to-page="{name:'detail.exercises', params: {eventId: props.row.event_id, executionId: props.row.execution_id}}"/>
      </b-table-column>
    </template>

    <section class="section" slot="empty">
      <div class="content has-text-grey has-text-centered">
        <template v-if="isLoading">
          <p>
            <b-icon icon="dots-horizontal" size="is-large" />
          </p>
          <p>Cargando Resultados...</p>
        </template>
        <template v-else>
          <p>
            <b-icon icon="horseshoe" size="is-large" />
          </p>
          <p>No hay Resultados&hellip;</p>
        </template>
      </div>
    </section>
  </b-table>
</template>

<script>
import ResultBinomialService from '@/services/ResultBinomialService'
import ScoreTag from '@/components/ScoreTag.vue'
import LinkToDetail from '@/components/LinkToDetail'
import LessonPdfButton from '@/components/LessonPDFButton'

export default {
  components: {
    ScoreTag,
    LinkToDetail,
    LessonPdfButton
  },
  props: {
    horseId: {
      required: true
    }
  },
  created () {
    this.getResults()
  },
  data () {
    return {
      activeTab: 1,
      horse: null,
      results: [],
      paginated: true,
      perPage: 10,
      isStriped: true,
      isNarrowed: false,
      hoverable: true,
      isFocusable: false,
      isLoading: false,
      totalScore: 0,
      numberResult: 0
    }
  },
  methods: {
    async getResults () {
      this.isLoading = true
      let params = {
        horse_id: this.horseId
      }
      let response = await ResultBinomialService.getResultsBinomial(params)
      this.results = response.data.data
      this.numberResult = this.results.length
      this.isLoading = false
      this.calculeScoreTotal()
    },
    calculeScoreTotal () {
      this.results.forEach((result) => {
        this.totalScore += parseFloat(result.final_score)
      })
      this.$emit('total-score-calculated', this.totalScore / this.results.length)
    }
  },
  watch: {
    horseId (value) {
      this.getResults()
    },
    numberResult (value) {
      this.$emit('number-result-changed', value)
    }
  }
}
</script>
